package com.neurobs.ccabserver.administrator.view

class AdminView(siteAdmin: Boolean) {
	import AdminView._
	import com.neurobs.js.view.Container
	import com.neurobs.js.dom.ElementFactory._
	import com.neurobs.js.dom.DOMViewElement._
	import com.neurobs.js.dom.AnchorLink
	import scalatags.JsDom.all._
	import com.neurobs.js.dom.Grid._

	private var linkDelimiter = false

	private val links = div(`class` := linksClass).render

	private val panel: PanelView = {
		val temp = new PanelView(if (siteAdmin) "Site Admin" else "Account Administration", showRefresh = false, fullWidth = true, Some(Array(("background-color", "#004"), ("color", "#FFFFFF"))))
		temp.grid.addRow(links)

		temp
	}

	private val firstPanelIndex = 1

	def container: Container = panel.container

	class PanelId(private[AdminView] val id: panel.grid.RowId )

	def addPanel(p: Container, after: Option[PanelId] = None): PanelId = {
		val element = toElement((p))
		new PanelId(
			after match {
				case None => panel.grid.insertRow(element, firstPanelIndex)
				case Some(id) => panel.grid.insertAfter(element, id.id)
			}
		)
	}

	def removePanel(id: PanelId): Unit = panel.grid.removeRow(id.id)

	def clearPanels(): Unit = {
		while (panel.grid.count > 1) panel.grid.removeRow(rowIndex = 1)
	}

	def addLink(title: String, handler: () => Unit): Unit = {
		val link: AnchorLink = makeLink(title)
		link.setHandler(handler)
		val s = if (linkDelimiter) span(" | ", link.anchor) else span(link.anchor)
		links.appendChild(s.render)
		linkDelimiter = true
	}
	def newLinkRow(): Unit = {
		links.appendChild(br.render)
		linkDelimiter = false
	}
}

object AdminView {
	private val linksClass = "admin-links"
}